export const environment = {
  production: false,
  staging: true,
  sandbox: false,
  metaTags: false,
  baseUrl: "https://staging.adaa.ae",
  apiUrl: "https://staging-api.adaa.ae/adaa-webapp-web-rest-api/",
  khadamatiApiUrl: "https://staging-api.adaa.ae/adaa-ws-khadamati-soap-client/",
  google_captcha_key: "6LfM7KsUAAAAAPuqoPTy5fAiqeucOrKqE4VeMIbc",
  google_maps: "AIzaSyAXfHV9wm7UL6DX7ocX7aYbjYffzrAaXMo",
  handsontable_key: "non-commercial-and-evaluation",
  glitchDns: "https://989cbbaadfb5446cac9b41d2619a875a@error.kalvad.com/33",
  reportingUrl: "https://staging-api.adaa.ae/adaa-webapp-reporting/",
  expressionToolsUrl: "https://staging-api.adaa.ae/adaa-webapp-expression-tools/",
  uaePass: {
    enable: true,
    loginUrl: "https://staging.adaa.ae/login",
    url: "https://stg-id.uaepass.ae/idshub/authorize",
    clientId: "pmo_adaa_web_stage",
    scope: "urn:uae:digitalid:profile:general",
    logoutUrl: "https://stg-id.uaepass.ae/idshub/logout",
  },
  adaa4Dashboards: {
    govDashboardAE: "https://adaa4stg.adaa.ae/ar/dashboard",
    govDashboardEN: "https://adaa4stg.adaa.ae/en/dashboard",
    strategyDashboardAE: "https://adaa4stg.adaa.ae/ar/dashboard/strategy-sector",
    strategyDashboardEN: "https://adaa4stg.adaa.ae/en/dashboard/strategy-sector",
    internationalDashboardEN: "https://adaa4stg.adaa.ae/ar/dashboard/international-projects",
    internationalDashboardAE: "https://adaa4stg.adaa.ae/en/dashboard/international-projects",
    agenticDashboardEN: "https://adaa4stg.adaa.ae/en/agentic-dashboard",
    agenticDashboardAE: "https://adaa4stg.adaa.ae/ar/agentic-dashboard",
  },
};
